import * as Yup from 'yup'

export const creationCleaningActivitiesSchema = Yup.object().shape({
  CompaniaId: Yup.string().required('Compañía es requerido'),
  ClienteId: Yup.string().required('Cliente es requerido'),
  SiteId: Yup.string().required('Site es requerido'),
  CampamentoId: Yup.string().required('Campamento es requerido'),
  TipoAccionId: Yup.string().nullable().defined('Tipo de Accion es requerido'),
  MinutosPromedio: Yup.number()
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value
    })
    .nullable()
    .required('Tiempo promedio es obligatorio'),
  ActividadId: Yup.string().nullable().when('TipoAccionId', {
    is: (val) => val === 'sb*C497NvTrTwv5sCdg1QCVUw8kWzRpD' || val === '4EsB2NAAsDA=',
    then: (schema) => schema.required('Actividad es requerido'),
    otherwise: (schema) => schema.nullable(),
  }),
  EstadoActividadId: Yup.string().required('Estado de Actividad es requerido'),
  TipoEdificacionId: Yup.string().nullable().when('TipoAccionId', {
    is: (val) => val === 'sb*C497NvTpwALLmCuBqbytj6NQoLhgP' || val === '4EsB2NAAsDA=',
    then: (schema) => schema.required('Tipo de Edificación es requerido'),
    otherwise: (schema) => schema.nullable(),
  })
  //ModuloId: Yup.string().nullable().defined('Módulo es requerido'),
  //HabitacionId: Yup.string().nullable().defined('Habitación es requerido'),
})
